export default __webpack_public_path__ + "static/media/umesh.2305357f.svg";